import { render, staticRenderFns } from "./exhibition-order-detail.vue?vue&type=template&id=1a2b4587&scoped=true&"
import script from "./exhibition-order-detail.vue?vue&type=script&lang=js&"
export * from "./exhibition-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-order-detail.vue?vue&type=style&index=0&id=1a2b4587&lang=scss&scoped=true&"
import style1 from "./exhibition-order-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b4587",
  null
  
)

export default component.exports